import { UPDATE_ADOBE_SETTINGS } from "../actionTypes";

const INITIAL_STATE = {
  isAdobeRefreshEnabled: false,
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_ADOBE_SETTINGS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default reducer;
